

export default () => {
    $(window).scroll(function() {
        if ($(document).scrollTop() > 100) {
            $('#header').addClass('scroll');
        }
        else {
            $('#header').removeClass('scroll');
        }
    });

    $(document).on('click', '.back-top', function () {
        $('html, body').animate({ scrollTop: 0 }, 1000);
    });
}
  
